module.exports = __webpack_public_path__ + "img/register-logo-pc.b0ac6efd.jpg";